<template>
  <div class="drug-venue-search">
    <van-search
      v-model="value"
      :show-action="action"
      @focus="focus"
      shape="round"
      :placeholder="placeholderText"
      @search="onSearch"
    >
      <template #left-icon>
        <img
          src="https://static.91jkys.com/third_files/GuoYao/202009/26/19c8a7398b1e4d25b3d18548be1e7690.png"
          class="icon_img"
          alt=""
        />
      </template>
      <template #right-icon>
        <div v-reClick="onSearch" class="search flex center">搜索</div>
      </template>
      <template #action>
        <div @click="cancel" class="cancel">取消</div>
      </template>
    </van-search>
  </div>
</template>
<script>
export default {
  props: ['showSiderbar', 'type'],
  computed: {
    placeholderText: function() {
      return this.type === 'goods' ? '商品名称 助记码' : '药品名称 助记码 适应症';
    }
  },
  data() {
    return {
      value: '',
      action: false
    };
  },
  methods: {
    onSearch() {
      // eslint-disable-next-line
      Telescope.trackEvent({ trackId: 'yd_category_search_input' });
      this.$emit('search', this.value);
    },
    focus() {
      // 控制只是初始查一下
      if (!this.showSiderbar) return;
      // eslint-disable-next-line
      Telescope.trackEvent({ trackId: 'yd_search_product' });
      this.$emit('update:showSiderbar', false);
      // 如果没有值 查一把数据
      if (!this.value) {
        this.$emit('search', this.value);
      }
      this.action = true;
    },
    cancel() {
      this.$emit('update:showSiderbar', true);
      this.$emit('cancel');
      this.action = false;
      this.value = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.drug-venue-search {
  ::v-deep.van-search__content {
    padding: 0 4px 0 12px;
  }
}
.van-search {
  padding: 6px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);

  .van-search__content {
    background: #f7f8fa;
  }

  .icon_img {
    width: 15px;
    margin-top: 12px;
  }
  ::v-deep.van-field__control {
    font-size: 14px;
  }
  ::v-deep.van-field__right-icon {
    margin: 3px -12px 3px 0;
  }

  .search {
    width: 52px;
    height: 30px;
    background: #1e8dff;
    border-radius: 18px;
    color: #fff;
    font-size: 14px;
  }
  ::placeholder {
    color: #bfbfbf;
    font-size: 14px;
  }
  .cancel {
    font-size: 14px;
    color: #595959;
  }
  // background: #f7f8fa;
}
</style>
